// extracted by mini-css-extract-plugin
export default {"market-range-text":"RnQ7Z3w___market-range-text","marketRangeText":"RnQ7Z3w___market-range-text"};